import {
  BoundedStakingOverviewQuery,
  BoundedStakingOverviewQuery$data,
  BoundedStakingOverviewQueryNode,
} from '@bts-web/data-layer/server';
import { gqlNetworkFetch } from '@bts-web/utils-relay';

export interface AssetsUnstakingOverviewResponse {
  data: BoundedStakingOverviewQuery$data;
  errors?: string[];
}

export const getAssetUnstakingOverviewData = async ({
  assetId,
}: {
  assetId: string;
}) => {
  const response = await gqlNetworkFetch<BoundedStakingOverviewQuery>(
    BoundedStakingOverviewQueryNode.params,
    { assetId },
  );

  return response;
};
